import * as React from 'react';

import { ISVGProps } from './SVG';

export function TrackingSVG({ width, height, title, fill }: ISVGProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.22 15.45" width={width} height={height}>
      <title>{title}</title>
      <g>
        <g>
          <g fill={fill}>
            <path
              d="M12.23 4.7A1.19 1.19 0 0011 5.9v11.64a1.2 1.2 0 001.16 1.23 1.18 1.18 0 001.22-1.16.08.08 0 000-.07V5.9a1.2 1.2 0 00-1.15-1.2z"
              transform="translate(-11.04 -3.32)"
            ></path>
            <path
              d="M16.65 8.43a1.21 1.21 0 00-1.2 1.2v7.91a1.19 1.19 0 001.19 1.2 1.2 1.2 0 001.2-1.19V9.63a1.21 1.21 0 00-1.19-1.2z"
              transform="translate(-11.04 -3.32)"
            ></path>
            <path
              d="M22.25 4.35a1.2 1.2 0 00-2.38.07v13.29a1.19 1.19 0 001.18 1h.18a1.21 1.21 0 001-1V4.35z"
              transform="translate(-11.04 -3.32)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
